import { render, staticRenderFns } from "./SimulatedSavingsDialog.vue?vue&type=template&id=26275f6f&lang=pug&"
import script from "./SimulatedSavingsDialog.vue?vue&type=script&lang=ts&"
export * from "./SimulatedSavingsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports